import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const InternshipDetailsForm = ({ formData, errors, onChange }) => {
  const durationOptions = [
    { value: '1-month', label: '1 Month' },
    { value: '2-months', label: '2 Months' },
    { value: '3-months', label: '3 Months' },
    { value: '6-months', label: '6 Months' },
    { value: '12-months', label: '12 Months' },
    { value: 'flexible', label: 'Flexible Duration' }
  ];

  if (!formData?.isInternship) {
    return (
      <div className="text-center py-12">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-muted mb-4">
          <svg className="w-8 h-8 text-muted-foreground" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h3 className="text-lg font-medium text-card-foreground mb-2">
          Not an Internship Position
        </h3>
        <p className="text-sm text-muted-foreground max-w-md mx-auto">
          This section is only required for internship positions. Since you selected a different job type, you can skip this step.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="bg-accent/10 border border-accent/20 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-8 h-8 rounded-full bg-accent/20 flex items-center justify-center">
            <svg className="w-5 h-5 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <h3 className="text-sm font-medium text-card-foreground mb-1">
              Internship-Specific Details
            </h3>
            <p className="text-sm text-muted-foreground">
              Provide additional information specific to internship positions, including duration, stipend, and mentorship opportunities.
            </p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Select
          label="Internship Duration"
          options={durationOptions}
          value={formData?.internshipDuration}
          onChange={(value) => onChange('internshipDuration', value)}
          error={errors?.internshipDuration}
          required
        />
        <Input
          label="Stipend Amount (INR per month)"
          type="number"
          placeholder="e.g., 15000"
          value={formData?.stipendAmount}
          onChange={(e) => onChange('stipendAmount', e?.target?.value)}
          error={errors?.stipendAmount}
          description="Enter 0 for unpaid internships"
          required
        />
      </div>

      <div className="space-y-4">
        <Checkbox
          label="Mentorship Program Available"
          description="This internship includes a structured mentorship program"
          checked={formData?.hasMentorship}
          onChange={(e) => onChange('hasMentorship', e?.target?.checked)}
        />

        {formData?.hasMentorship && (
          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Mentorship Program Details
            </label>
            <textarea
              className="flex min-h-[100px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
              placeholder="Describe the mentorship program...\n• One-on-one mentoring sessions\n• Weekly feedback and guidance\n• Career development support\n• Skill-building workshops"
              value={formData?.mentorshipDetails}
              onChange={(e) => onChange('mentorshipDetails', e?.target?.value)}
              rows={5}
            />
          </div>
        )}
      </div>

      <div className="bg-muted/50 rounded-lg p-4">
        <h4 className="text-sm font-medium text-card-foreground mb-3">
          Internship Benefits & Perks
        </h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <Checkbox
            label="Certificate of Completion"
            checked={formData?.certificateProvided}
            onChange={(e) => onChange('certificateProvided', e?.target?.checked)}
          />
          <Checkbox
            label="Letter of Recommendation"
            checked={formData?.recommendationLetter}
            onChange={(e) => onChange('recommendationLetter', e?.target?.checked)}
          />
          <Checkbox
            label="Pre-Placement Offer (PPO) Opportunity"
            checked={formData?.ppoOpportunity}
            onChange={(e) => onChange('ppoOpportunity', e?.target?.checked)}
          />
          <Checkbox
            label="Flexible Working Hours"
            checked={formData?.flexibleHours}
            onChange={(e) => onChange('flexibleHours', e?.target?.checked)}
          />
        </div>
      </div>
    </div>
  );
};

export default InternshipDetailsForm;